// ----------------------------------------------------------------------------- //
// 	Update input range
// ----------------------------------------------------------------------------- //
export default function handleInputRangeChange( ref = document ) {

	const inputFile = ref.querySelectorAll('.input-file');

	if ( inputFile.length ) {
		inputFile.forEach( (e) => {

			const file = e.nextElementSibling.querySelector('.input-file-appearance__name');

			e.addEventListener( "change", () => {
				const fileName = e.value.split( '\\' ).pop();
				file.innerHTML = fileName;
			});
		});
	}
};
